import { PRODUCT_NAME } from "@playbookai/types";
import { ARTICLE_FIGURES } from "./article-figures.js";
import { knowledgeArticleTags } from "./tags.js";
/** Resolve product placeholders and attach canonical tags and figures to guide content. */
export function defineArticles(articles) {
    const resolve = (text) => text.replaceAll("{product}", PRODUCT_NAME);
    return articles.map((article) => ({
        ...article,
        tags: knowledgeArticleTags(article),
        ...(ARTICLE_FIGURES[article.id]
            ? { figures: ARTICLE_FIGURES[article.id] }
            : {}),
        title: resolve(article.title),
        summary: resolve(article.summary),
        body: resolve(article.body),
        ...(article.solution ? { solution: resolve(article.solution) } : {}),
    }));
}
//# sourceMappingURL=define.js.map